import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import logo from "../img/logo2.png";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Link } from "react-router-dom";
import { login } from "../functions/auth"
import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({

    container: {
        background: "#f3f3f3",
        height: "680px"


    },

    wrapper: {
        textAlign: "center",

    },

    logo: {
        width: "300px",
        margin: "50px",
        "@media (max-width: 770px)": {
            width: "60%"
        }
    },

    input: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        color: "#929292",
        border: "none",
        outline: "none",
        width: "570px",
        height: "61px",
        padding: "0 30px",
        marginBottom: "15px",
        boxShadow: "0 10px 10px rgb(225 225 225)",
        fontSize: "16px",
        "&:focus": {
            boxShadow: "0 0 5px #9ed4ff",
            border: "0px solid #558ab7 !important"
        },
        "@media (max-width: 770px)": {
            width: "80%"
        }

    },
    button: {
        backgroundColor: "#3ad1bf",
        color: "#fff",
        fontSize: "30px",
        width: "630px",
        height: "82px",
        borderRadius: "10px",
        border: "0",
        "&:hover": {
            boxShadow: "0 0 5px #9ed4ff",
            border: "0px solid #558ab7 !important",
            cursor: 'pointer'
        },
        "@media (max-width: 770px)": {
            width: "95%",
            height: "61px"
        }


    },

    wrapper2: {
        textAlign: "center"

    },
    Link: {
        color: "#666",
        fontSize: "18px",
        fontWeight: 400,
        textDecoration: "none",
        margin: "10px"
    }

}))


const Login = () => {

    const history = useHistory();
    const dispatch = useDispatch();

    const style = useStyles();

    const [inputs, setInputs] = useState({
        id: "",
        pw: ""
    });

    const { id, pw } = inputs;

    const onChange = (e) => {

        const { value, name } = e.target;

        setInputs({
            ...inputs,
            [name]: value
        })

        // console.log(inputs)

    }

    const onSubmit = async (e) => {

        e.preventDefault();

        if (!id.includes("@")) {
            alert("아이디는 이메일 형식으로 입력해주세요.")
            return;
        }

        if (!pw) {
            alert("비밀번호를 입력해주세요.")
            return;
        }

        const { data } = await login(id, pw, null);

        //console.log(data);

        if (data.type) {

            window.localStorage.setItem(`${process.env.REACT_APP_TOKEN_KEY}`, data.token);
            dispatch({
                type: "LOGGED_IN_USER",
                payload: {
                    userID: data.data.userID,
                    name: data.data.name,
                    credit: data.data.points
                }
            })

        } else {

            return alert(data.data);

        }


        setInputs({
            id: "",
            pw: ""
        })

        history.push("/");

    }

    const Input = useRef();

    return (
        <div>
            <div className={style.container}>
                <form className={style.wrapper}>
                    <img src={logo} alt="logo" className={style.logo} />
                    <br />
                    <input className={style.input} value={id} ref={Input} required={true} type="email" name="id" placeholder="아이디(학교이메일)" onChange={(e) => onChange(e)} />
                    <br />
                    <input className={style.input} value={pw} ref={Input} required={true} type="password" name="pw" placeholder="비밀번호" onChange={(e) => onChange(e)} />
                    <br />
                    <button type="button" className={style.button} onClick={e => onSubmit(e)}>로그인</button>
                    <div>
                        <FormControlLabel control={<Checkbox color="primary" />} label="로그인 상태 유지" />
                    </div>
                </form>
                <br />

                <div className={style.wrapper2}>
                    <Link to="" className={style.Link}>아이디 찾기</Link>
                    <span>I</span>
                    <Link to="" className={style.Link}>비밀번호 찾기</Link>
                    <span>I</span>
                    <Link to="" className={style.Link}>회원가입</Link>
                    <br />
                    <br />
                    <Link to="" className={style.Link}>비회원 둘러보기</Link>
                </div>

            </div>
        </div>
    );
};

export default Login;